import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, flatMap, map, mergeMap, Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals';
import { SideNavbarService } from 'src/app/side-navbar/side-navbar.service';
import { environment } from 'src/environments/environment';
import { OrganisationService } from '../organisation.service';

@Component({
  selector: 'organisations-by-education-type-and-organisation',
  templateUrl: './organisations-by-education-type-and-organisation.component.html',
  styleUrls: ['./organisations-by-education-type-and-organisation.component.css']
})
export class OrganisationsByEducationTypeAndOrganisationComponent implements OnInit, OnDestroy {

  @Input('education-type-id') educationTypeId!: any;
  @Input('organisation-unit-id') organisationUnitId!: any;
  @Input('period') period!: any;
  //period: any;
  organisation: any;
  organisations: any;
  isLoaded = false;
  organisationUnit: any = environment.frontPageOrganisationIndex;
  frontPageRoute: any = environment.frontPageRoute;
  header: any;
  parent: any;
  params: any;
  id: any;
  errorMessage: any;
  // subscriptions
  private subscription: Subscription = new Subscription();
  
  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private navigationService: SideNavbarService,
    //private titleService: Title,
    private service: OrganisationService
  ) { 
    
      //this.ngOnInit();
      

    this.subscription.add(this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.initialiseInvites();
      }
    }));
  }

  initialiseInvites() {
    // Set default values and re-fetch any data you need.
    // tällä saadaan aikaan latauspalkki
    this.subscription.add(this.route.url.subscribe(url => {
      this.isLoaded = false;
    }));
    this.ngOnInit();
  }


  ngOnInit(): void {
    //console.log('alustetaan aliorganisaatiot yksikölle: ' + this.organisationUnitId)
    this.getOrgs();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getOrgs() {
    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        organisationId: params[0].get('organisation-unit-id'), 
        period: params[1].get('period')
      })),
      // haetaan aliorganisaatiot
      mergeMap(params => {
        this.organisationUnitId = params.organisationId;
        this.period = params.period;
        //this.setCurrentUrl();
        return this.service.getSubOrganisations(this.organisationUnitId);
        //return this.organisationUnitId == null ? this.service.getOrganisations() : this.service.getSubOrganisations(this.organisationUnitId);  
      })).subscribe(
        subOrganisations => {
          this.organisations = subOrganisations;
          this.globals.sortByName2(this.organisations, this.globals.lang);
          this.isLoaded = true;
        }
      ));
  }


 /* getOrganisations() {
    if(this.organisationUnitId != undefined) {
      this.subscription.add(this.service.getSubOrganisations(this.organisationUnitId).subscribe((value => {
        this.organisations = value;
        this.globals.sortByName2(this.organisations, this.globals.lang);
        //this.getParent();
        this.isLoaded = true;
      })));
    } else {
      console.log('tän tultiin')
    }
  }*/

  /**
   * Palauttaa sivua vastaavan koulutustyypin tiedot sivun otsikkoa
   * varten (parent), sekä puurakenteen linkityksiä varten (educationType)
   */
  /*getParent() {
    this.subscription.add(combineLatest(this.route.paramMap, this.route.queryParamMap).pipe(
      map(params => ({
        id: params[0].get('id'), 
        period: params[1].get('period')
      })),
      flatMap((params) => {
          this.organisationUnitId = params.id;
          this.period = params.period;
          return this.navigationService.getNavigationItem((this.organisationUnitId));     
      })
    ).subscribe(value => {
      this.parent = value;
      this.educationTypeId = this.parent.id;
      //this.setCurrentUrl();
      //this.setTitle();
    }, error => this.errorMessage = <any>error));
  }*/

  /*this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
    map(params => ({
      programmeId: params[0].get('id'), 
      period: params[1].get('period')
    })),
    // haetaan ajoitussuunnitelma
    mergeMap(params => {
      this.programmeId = params.programmeId;
      this.period = params.period;
      this.setCurrentUrl();
      return this.programmeService.getProgrammeWithLearningUnit(this.programmeId);
    }),
    //haetaan kuvaus
    mergeMap(programme => {
      this.programme = programme;
      if (this.programme.length > 0) {
        this.setTitle();
      }
      return this.programmeService.getProgrammeDescription(this.programmeId);
    }),
    //haetaan periodien lkm tiettynä vuotena
    mergeMap(description => {
      this.programmeDescription = description;
      return this.programmeService.getPeriodCountByYear(Number(this.period.split('-')[0]), this.programme[0].duration);
    }),
    //haetaan ajoitussuunnitelmat valikkoon
    mergeMap(periodCount => {
      this.periodCount = periodCount;
      return this.programmeService.getAccomplishmentPlanList(this.programmeId);
    })
    ).subscribe(
      accomplishmentPlans => {
        this.accomplishmentPlans = accomplishmentPlans;
        //oletuksena näytetään listan ensimmäinen
        this.selectedPlan = this.accomplishmentPlans[0];
        this.isLoaded = true;
      },
      error => this.errorMessage = <any>error
    ));*/


}
